(function($) {
    'use strict';

    let visitedVendors = localStorage.getItem('visited-vendors');

    if (null === visitedVendors) {
        visitedVendors = [];
    } else {
        visitedVendors = JSON.parse(visitedVendors);
    }

    const addVisitedVendor = function(vendorId) {
        visitedVendors.push(vendorId);
        localStorage.setItem('visited-vendors', JSON.stringify(visitedVendors));
    };

    $('[data-job-fair-vendor]').each(function() {
        const $this = $(this);
        const vendorId = parseFloat($this.data('job-fair-vendor'));

        if (visitedVendors.indexOf(vendorId) >= 0) {
            $this.attr('data-attribute-visited', '');
        } else {
            $this.attr('data-attribute-notvisited', '');
            $this.find('a').on('click', function() {
                addVisitedVendor(vendorId);
                return true;
            });
        }
    });

    $('.job-fair-vendor-industries').each(function() {
        const $filters = $(this);
        const $filterContainers = $filters.find('.filter-container');

        $filterContainers.each(function() {
            const $filterContainer = $(this);

            $filterContainer.children('h2').on(Utils.clickEvent, function() {
                $filterContainer.siblings().removeClass('show');
                $filterContainer.toggleClass('show');
            });
        });

        $(document).on(Utils.clickEvent, function(e) {
            if ($(e.target).closest('.filter-container').length === 0) {
                $filterContainers.removeClass('show');
            }
        });

        const $newsItems = $('.job-fair-vendor');
        let attribute;
        let keyword;

        const filterNews = function() {
            $newsItems.hide().filter(function() {
                const $this = $(this);
                let hasAttribute = true;
                let hasKeyword = true;

                if (attribute) {
                    hasAttribute = typeof $(this).attr('data-attribute-'+attribute) !== 'undefined';
                }

                if (keyword) {
                    hasKeyword = $this.find('.link-tiles__headline').text().toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
                }

                return hasAttribute && hasKeyword;
            }).show();
        };

        $filters.find('.attribute-filter').each(function() {
            const $attributeFilter = $(this);

            $attributeFilter.find('a').on(Utils.clickEvent, function(e) {
                e.preventDefault();

                const $link = $(this);
                $link.closest('li').siblings().find('a').removeClass('active');
                $link.addClass('active');

                $filterContainers.removeClass('show');

                attribute = $(this).data('attribute');

                if (!attribute) {
                    $attributeFilter.removeClass('filter-active');
                } else {
                    $attributeFilter.addClass('filter-active');
                }

                filterNews();

                return false;
            });
        });

        $filters.find('.search-filter input').on('input', function() {
            keyword = $(this).val();
            filterNews();
        });
    });

})(jQuery);
